import * as React from 'react'

import { Experiment, Variant } from './types'

export interface ExperimentsContextData {
  experiment?: Experiment
  selectedVariantId?: string
}

export const ExperimentsContext = React.createContext<ExperimentsContextData>({})
